import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PatientPortalService } from '../patient-portal.service';
import { ApptStatusEnum } from 'src/app/models/enum/appt-status.enum';

@Component({
  selector: 'app-patient-portal-confirm-appointment',
  templateUrl: './patient-portal-confirm-appointment.component.html',
  styleUrls: ['./patient-portal-confirm-appointment.component.css']
})
export class PatientPortalConfirmAppointmentComponent implements OnInit {

  isLoading: boolean = false;
  AppointmentId: string;
  PatientId: string;
  appointment: any;

  arriveTimes: any[] = [];
  arrivalTime: string;

  //enumConfirmedStatus: string = '00000072-0000-0000-0000-000000000008';

  constructor(
    public dialogRef: MatDialogRef<PatientPortalConfirmAppointmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly infoService: PatientPortalService,
  ) {
    console.log('PatientPortalConfirmAppointmentComponent: ', this.data);
    this.AppointmentId = this.data.AppointmentId;
    this.PatientId = this.data.PatientId;
    this.appointment = this.data.appointment;
  }

  ngOnInit() {
    this.setupArrivalTimes();
  }

  setupArrivalTimes() {
    const startDate = new Date(this.appointment.StartDate);
    
    let newDateObj = new Date(startDate.getTime() - 60*60000);
    for (let i = 0; i < 4; i++) {
      const textDate =   newDateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

      newDateObj = new Date(newDateObj.getTime() + 15*60000);
      this.arriveTimes.push(textDate);
    }
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  confirmAppointment() {
    this.isLoading = true;
    this.setAppointmentStatus(ApptStatusEnum.Confirmed)
      .then((appointment: any) => {
        this.close(appointment);
      }, err => {
        this.close('error');
      });
  }

  setAppointmentStatus(status: string) {
    let promise = new Promise((resolve, reject) => {
      this.infoService.setAppointmentStatus(this.AppointmentId, status)
        .subscribe(resolve, reject);
    });
    return promise;
  }

}
